import { createAsyncThunk } from '@reduxjs/toolkit'
import { AIPlayerSenderType } from '@/constants/chat'
import { AppDispatch, RootState } from '@/redux/store'
import WebSocketManager from '@/services/websocketManager'
import { addMessage, removeMessageById } from '@/redux/slices/aiPlayerChatSlice'

const wsManager = WebSocketManager.getInstance()

export const connectAIPlayerWebSocket = createAsyncThunk<
  void,
  { jwtToken: string; roomId: string; teamId: string },
  { dispatch: AppDispatch; state: RootState }
>('websocket/connectAIPlayer', async ({ jwtToken, roomId, teamId }) => {
  return wsManager.connectToAIPlayerChat(jwtToken, roomId, teamId)
})

export const disconnectAIPlayerWebSocket = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch }
>('websocket/disconnectAIPlayer', async () => {
  return wsManager.disconnect('ai_player_chat')
})

export const loadAIPlayerThread = createAsyncThunk<
  void,
  { page?: number },
  { dispatch: AppDispatch; state: RootState }
>('websocket/loadAIPlayerThread', async ({ page = 1 }, { rejectWithValue }) => {
  const success = wsManager.sendMessage('ai_player_chat', {
    type: 'LOAD_THREAD',
    page,
  })
  if (!success) {
    return rejectWithValue('AI Player WebSocket not connected')
  }
})

export const sendAIPlayerMessage = createAsyncThunk<
  void,
  { message: string; idempotencyKey?: string },
  { dispatch: AppDispatch; state: RootState }
>(
  'websocket/sendAIPlayerMessage',
  async ({ message, idempotencyKey }, { dispatch, rejectWithValue }) => {
    const trimmed = message.trim()
    if (!trimmed) {
      return rejectWithValue('Empty message')
    }
    const optimisticId = -Math.abs(Date.now())
    dispatch(
      addMessage({
        id: optimisticId,
        sender_type: AIPlayerSenderType.Player,
        content: trimmed,
        created_at: new Date().toISOString(),
      })
    )
    const success = wsManager.sendMessage('ai_player_chat', {
      type: 'SEND_PLAYER_MESSAGE',
      message: trimmed,
      idempotency_key: idempotencyKey,
    })
    if (!success) {
      dispatch(removeMessageById(optimisticId))
      return rejectWithValue('AI Player WebSocket not connected')
    }
  }
)
